import { createActions } from 'redux-actions'

import { createFormActions, identityAction } from '../../utils/actions'

export const {
  jobmail: {
    subscribe,
    subscribeSuccess,
    subscribeFailure,
    openSearchJobmail,
    closeSearchJobmail,
    modalOpen: jobmailModalOpen,
    modalClose: jobmailModalClose,
    resendActivation
  }
} = createActions({
  JOBMAIL: {
    ...createFormActions('SUBSCRIBE'),
    OPEN_SEARCH_JOBMAIL: identityAction,
    CLOSE_SEARCH_JOBMAIL: null,
    MODAL_OPEN: null,
    MODAL_CLOSE: null,
    RESEND_ACTIVATION: identityAction
  }
})
